/**
 * Project : workspace
 * File    : PricingEngine.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package engine.pricing

import com.parmartechnologies.core.feature.product.model.ProductPrice
import com.parmartechnologies.core.feature.sale.model.Sale
import engine.math.MathEngine
import kotlin.time.ExperimentalTime


/**
 * Represents the pricing engine class.
 */


class PricingEngine {

    @OptIn(ExperimentalTime::class)
    fun calculateInvoicePrice(saleItems: List<Sale>?): ProductPrice {
        var totalTax = 0.0
        var totalFinalPrice = 0.0
        var totalSalePrice = 0.0
        val pricingDetails = ProductPrice()
        saleItems?.forEach { sale ->
            totalFinalPrice += sale.FinalPrice
            totalTax += sale.Tax
            totalSalePrice += sale.SalePrice * sale.Quantity
        }
        pricingDetails.Tax = totalTax
        pricingDetails.FinalPrice = totalFinalPrice
        pricingDetails.SalePrice = totalSalePrice
        return pricingDetails
    }

    /**
 * Executes the compute percent to value operation.
 *
 * @receiver TODO
 * @param Amount The amount.
 * @param percentValue The percent value.
 * @return The resulting double.
 */

    fun computePercentToValue(Amount: Double?, percentValue: Double?): Double {
        return (Amount!! * percentValue!!)/100
    }

    /**
 * Executes the calculate tax operation.
 *
 * @receiver TODO
 * @param taxIncluded The tax included.
 * @param amount The amount.
 * @param totalTaxPercent The total tax percent.
 * @return The resulting double.
 */

    fun calculateTax(taxIncluded: Boolean, amount: Double, totalTaxPercent: Double): Double {
        val taxedAmount = if (taxIncluded) {
            (amount * totalTaxPercent) / (totalTaxPercent + 100)
        } else {
            computePercentToValue(amount, totalTaxPercent)
        }
        return MathEngine().roundTo(taxedAmount, 2)
    }

}